import React, { Fragment } from 'react';
import Dropzone, { DropzoneRenderArgs } from 'react-dropzone';

import { uriToBlob } from 'utils/file';

import {
  Remove,
  CustomIcon,
  ThumbImage,
  SignatureText,
  StyledDropzone,
  SignatureThumbContainer,
  UploadSignatureContainer,
} from './styles';
import Toast from 'components/Notify';
import Compressor from 'compressorjs';
import notify from '../../../../components/Notify';
import { ICompanyMember, IDocumentView } from 'store/companies/companiesTypes';
import i18n from '../../../../i18n';

interface IComponentProps {
  addSignature: (file: unknown | null) => Promise<any>;
  member: ICompanyMember;
  removeSignature: () => Promise<any>;
  revert: () => void;
  removing?: boolean;
  disabled?: boolean;
}

interface IComponentStates {
  file: IDocumentView | null;
  // saving: boolean;
  // removing: boolean;
  // uploading: boolean;
}

const MAX_SIZE = 128000;
const ACCEPTED_TYPES = 'image/*';

class MemberSignature extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    file: null,
  };

  handleAcceptedFiles = (files: DropzoneRenderArgs['acceptedFiles']) => {
    const acceptedFile = files[0];
    const { size } = acceptedFile;

    if (size > MAX_SIZE)
      new Compressor(acceptedFile, {
        quality: MAX_SIZE / size / 2,
        convertSize: MAX_SIZE,
        success: (result: any) => {
          if (result.size < MAX_SIZE) this.setSignature(result);
          else
            notify(
              i18n.t('failedToCompressImage', { ns: 'companyManagement' }),
              'warning'
            );
        },
        error: () => {
          notify(
            i18n.t('failedToCompressImage', { ns: 'companyManagement' }),
            'warning'
          );
        },
      });
    else this.setSignature(acceptedFile);
  };

  private setSignature(acceptedFile: File) {
    const { name, size, type } = acceptedFile;
    const file: IDocumentView = {
      url: URL.createObjectURL(acceptedFile),
      fileSize: size,
      properties: {
        format: type.split('/')[1],
        displayName: name,
      },
    };
    this.setState(
      {
        file,
      },
      async () => {
        const blob = await uriToBlob(this.state.file!.url);

        if (blob) {
          this.props.addSignature(blob);
        }
      }
    );
  }

  handleRejectedFiles = (files: DropzoneRenderArgs['rejectedFiles']) => {
    const file = files[0];
    let warningMessage;
    if (file.size > MAX_SIZE) {
      warningMessage = i18n.t('sizeOfTheFileShouldBeLessThanTenMB', {
        ns: 'companyManagement',
      });
    } else {
      warningMessage = i18n.t('onlyImagesAreValid', {
        ns: 'companyManagement',
      });
    }
    Toast(warningMessage, 'warning');
  };

  handleRemove = () => {
    this.setState({ file: null });
    this.props.removeSignature();
  };
  handleRevert = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ file: null });
    this.props.revert();
  };

  // handleSave = async () => {
  //   this.setState({ saving: true });
  //   if (this.state.removing) {
  //     const { member, removeSignature } = this.props;
  //     removeSignature(member.companyId, member.userId);
  //     // .then(() => {
  //     //   this.setState({
  //     //     removing: false,
  //     //     saving: false,
  //     //   });
  //     //   Toast(messages.imageOfSignatureRemovedSuccessfully);
  //     // })
  //     // .catch((err) => {
  //     //   this.setState({
  //     //     saving: false,
  //     //     removing: false,
  //     //   });
  //     //   display(err);
  //     // });
  //   } else if (this.state.uploading && this.state.file) {
  //     const { member, addSignature } = this.props;
  //     const blob = await uriToBlob(this.state.file.url);
  //
  //     if (blob) {
  //       addSignature(member.companyId, member.userId, blob).then(() => {
  //       });
  //     }
  //   }
  // };

  render() {
    const { member, disabled } = this.props;
    return (
      <UploadSignatureContainer loading={false}>
        <Fragment>
          {member.signature && !this.props.removing && !this.state.file ? (
            <SignatureThumbContainer>
              {!disabled && (
                <Remove type="x" color="red" onClick={this.handleRemove} />
              )}
              <a
                target="_blank"
                href={member.signature.url}
                rel="noopener noreferrer"
              >
                <ThumbImage
                  src={member.signature.thumbnailUrl || member.signature.url}
                />
              </a>
            </SignatureThumbContainer>
          ) : (
            <Fragment>
              {this.state.file ? (
                <SignatureThumbContainer>
                  {!disabled && (
                    <Remove type="x" color="red" onClick={this.handleRemove} />
                  )}
                  <a
                    target="_blank"
                    href={this.state.file.url}
                    rel="noopener noreferrer"
                  >
                    <ThumbImage
                      src={this.state.file.thumbnailUrl || this.state.file.url}
                    />
                  </a>
                </SignatureThumbContainer>
              ) : (
                <Dropzone
                  style={StyledDropzone}
                  accept={ACCEPTED_TYPES}
                  disabled={disabled}
                  multiple={false}
                  onDropRejected={this.handleRejectedFiles}
                  onDropAccepted={this.handleAcceptedFiles}
                >
                  {/*@ts-expect-error JSX error*/}
                  {() => (
                    <div>
                      {!disabled && member.signature && (
                        <Remove
                          type="rotate-ccw"
                          color="red"
                          onClick={this.handleRevert}
                        />
                      )}
                      <CustomIcon disabled={disabled} type="plus" />
                      <SignatureText>
                        {i18n.t('signature', {
                          ns: 'companyManagement',
                        })}
                      </SignatureText>
                    </div>
                  )}
                </Dropzone>
              )}
            </Fragment>
          )}
        </Fragment>
      </UploadSignatureContainer>
    );
  }
}

export default MemberSignature;
